import { computeRoutePdfLength } from "utils/computeRoutePdfLength";
import type { DeleteNodeFromRoute } from "./types";

export const deleteNodeFromRoute: DeleteNodeFromRoute = ({
  geometry,
  nodeId,
}) => {
  if (geometry.nodes.length <= 2) return null;

  const incomingEdges = geometry.edges.filter((edge) => edge.to === nodeId);
  const outgoingEdges = geometry.edges.filter((edge) => edge.from === nodeId);
  const otherEdges = geometry.edges.filter(
    (edge) => edge.from !== nodeId && edge.to !== nodeId,
  );

  const isMiddleNode =
    incomingEdges.length === 1 && outgoingEdges.length === 1;
  const isEndpoint =
    (incomingEdges.length === 0 && outgoingEdges.length === 1) ||
    (incomingEdges.length === 1 && outgoingEdges.length === 0);

  if (!isMiddleNode && !isEndpoint) return null;

  const mergedEdges = isMiddleNode
    ? [
        ...otherEdges,
        { from: incomingEdges[0].from, to: outgoingEdges[0].to },
      ]
    : otherEdges;

  const updatedNodes = geometry.nodes.filter((node) => node.id !== nodeId);
  const polylineLength = computeRoutePdfLength({
    nodes: updatedNodes,
    edges: mergedEdges,
  });

  return {
    nodes: updatedNodes,
    edges: mergedEdges,
    polylineLength,
  };
};
